import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M11.576 2.576a.6.6 0 0 1 .848 0l5 5a.6.6 0 0 1-.848.848L12.6 4.45V15a.6.6 0 1 1-1.2 0V4.449L7.424 8.424a.6.6 0 0 1-.848-.848l5-5ZM3 14.4a.6.6 0 0 1 .6.6v1.2c0 .85 0 1.451.039 1.922.038.463.11.745.223.968a2.4 2.4 0 0 0 1.048 1.048c.223.114.505.185.968.223.47.038 1.072.039 1.922.039h8.4c.85 0 1.451 0 1.922-.039.463-.038.745-.11.968-.223a2.4 2.4 0 0 0 1.048-1.048c.114-.223.185-.505.223-.968.039-.47.039-1.072.039-1.922V15a.6.6 0 0 1 1.2 0v1.226c0 .818 0 1.469-.043 1.993-.044.538-.136.996-.35 1.415a3.6 3.6 0 0 1-1.573 1.574c-.42.213-.877.305-1.415.35-.524.042-1.175.042-1.993.042H7.774c-.818 0-1.468 0-1.993-.043-.538-.044-.996-.136-1.415-.35a3.6 3.6 0 0 1-1.574-1.573c-.213-.42-.305-.877-.35-1.415-.042-.524-.042-1.175-.042-1.993V15a.6.6 0 0 1 .6-.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
